export default __webpack_public_path__ + "static/media/realstate3.3668a186.PNG";